import React from 'react';
import { Redirect } from 'react-router-dom';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import Profil from 'src/views/Profile';
import UnauthorizedView from 'src/views/Unauthorized';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import ChatView from './views/Chat';
import CountingView from './views/Counting';
import ScrapView from './views/Scrap';
import CustomerCareView from './views/CustomerCare';
import ScrapReportView from './views/ScrapReport';
import ResetView from './views/Reset';
import ArcelikReturnView from './views/ArcelikReturn';
import YardimView from './views/Help';
import DebitView from './views/Material/MaterialExit/Debit';
import BranchView from './views/Material/MaterialExit/Branch';
import PassOutView from './views/Material/MaterialExit/PassOut';
import SaleView from './views/Material/MaterialExit/Sale';
import InvoiceView from './views/Material/MaterialLogin/Invoice';
import { default as PassView, default as RustingView } from './views/Material/MaterialLogin/Pass';
import PurchaseView from './views/Material/MaterialLogin/Purchase';
import RefundView from './views/Material/MaterialLogin/Refund';
import MaterialSearchView from './views/MaterialSearch';
import ProductSearchView from './views/ProductSearch';
import EndOfDayView from './views/Reports/EndOfDay';
import StockActionView from './views/Reports/StockAction';
import WarehouseView from './views/Warehouse';
import OpenPassView from './views/PassMain/OpenPass';
import MyPassView from './views/PassMain/MyPass';
import MyPassSendView from './views/PassMain/MyPassSend';
import PassConfirmView from './views/PassMain/PassConfirm';
import PassMoneyConfirmView from './views/PassMain/PassMoneyConfirm';
import CardSaveView from './views/PassMain/CardSave';
import InvoiceTrackingView from './views/PassMain/InvoiceTracking';


import TechnicianPlanView from './views/TechnicianPlan';
import ServiceShopPlanView from './views/ServiceShopPlan';
import InventoryReportView from './views/InventoryReport';
import InventoryDetailReportView from './views/InventoryDetailReport';
import InvoiceDiffView from './views/InvoiceDiff';
import OrderListView from './views/OrderList';
import AirConditioningConsumablesView from './views/AirConditioningConsumables';
import CirculationView from './views/Circulation';
import ArcelikReturnReportView from './views/ArcelikReturnReport';
import CirculationDifferenceView from './views/CountingDifference';
import StateOfInactivityView from './views/StateOfInactivity';
import MultipleUsesMaterialView from './views/MultipleUsesMaterial';
import ServicePaperPurchaseView from './views/Material/MaterialLogin/ServicePaperPurchase';


export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: UnauthorizedView
      },
      {
        component: () => <Redirect to="/Unauthorized" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/Counting',
        exact: true,
        component: CountingView
      },
      {
        path: '/Scrap',
        exact: true,
        component: ScrapView
      },
      {
        path: '/CustomerCare',
        exact: true,
        component: CustomerCareView
      },

      {
        path: '/ScrapReport',
        exact: true,
        component: ScrapReportView
      },
      {
        path: '/Reset',
        exact: true,
        component: ResetView
      },
      {
        path: '/ArcelikReturn',
        exact: true,
        component: ArcelikReturnView
      },
      {
        path: '/Invoice',
        exact: true,
        component: InvoiceView
      },
      {
        path: '/MyPass',
        exact: true,
        component: MyPassView
      },
      {
        path: '/MyPassSend',
        exact: true,
        component: MyPassSendView
      },
      {
        path: '/OpenPass',
        exact: true,
        component: OpenPassView
      },
      {
        path: '/PassConfirm',
        exact: true,
        component: PassConfirmView
      },
      {
        path: '/PassMoneyConfirm',
        exact: true,
        component: PassMoneyConfirmView
      },
      {
        path: '/CardSave',
        exact: true,
        component: CardSaveView
      },
      {
        path: '/InvoiceTracking',
        exact: true,
        component: InvoiceTrackingView
      },

      {
        path: '/Pass',
        exact: true,
        component: PassView
      },
      {
        path: '/Purchase',
        exact: true,
        component: PurchaseView
      },
      {
        path: '/ServicePaperPurchase',
        exact: true,
        component: ServicePaperPurchaseView
      },
      {
        path: '/Refund',
        exact: true,
        component: RefundView
      },
      {
        path: '/Debit',
        exact: true,
        component: DebitView
      },
      {
        path: '/PassOut',
        exact: true,
        component: PassOutView
      },
      {
        path: '/Sale',
        exact: true,
        component: SaleView
      },
      {
        path: '/Branch',
        exact: true,
        component: BranchView
      },
      {
        path: '/Rusting',
        exact: true,
        component: RustingView
      },
      {
        path: '/MaterialSearch',
        exact: true,
        component: MaterialSearchView
      },
      {
        path: '/ProductSearch',
        exact: true,
        component: ProductSearchView
      },
      {
        path: '/Warehouse',
        exact: true,
        component: WarehouseView
      },
      {
        path: '/TechnicianPlan',
        exact: true,
        component: TechnicianPlanView
      },
      {
        path: '/ServiceShopPlan',
        exact: true,
        component: ServiceShopPlanView
      },
      {
        path: '/Yardim',
        exact: true,
        component: YardimView
      },
      {
        path: '/Chat',
        exact: true,
        component: ChatView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/StockAction',
        exact: true,
        component: StockActionView
      },
      {
        path: '/EndOfDay',
        exact: true,
        component: EndOfDayView
      },
      {
        path: '/InventoryReport',
        exact: true,
        component: InventoryReportView
      },
      {
        path: '/InventoryDetailReport',
        exact: true,
        component: InventoryDetailReportView
      },

      {
        path: '/InvoiceDiff',
        exact: true,
        component: InvoiceDiffView
      },
      {
        path: '/OrderList',
        exact: true,
        component: OrderListView
      },
      {
        path: '/AirConditioningConsumables',
        exact: true,
        component: AirConditioningConsumablesView
      },
      
      {
        path: '/Circulation',
        exact: true,
        component: CirculationView
      },
      {
        path: '/ArcelikReturnReport',
        exact: true,
        component: ArcelikReturnReportView
      },
      {
        path: '/CountingDifference',
        exact: true,
        component: CirculationDifferenceView
      },

      {
        path: '/StateOfInactivity',
        exact: true,
        component: StateOfInactivityView
      },

      {
        path: '/MultipleUsesMaterial',
        exact: true,
        component: MultipleUsesMaterialView
      },




      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
